// extracted by mini-css-extract-plugin
export default {"wrapper":"horisontal-shift-animation_wrapper__PqlaA","inner_container":"horisontal-shift-animation_inner_container__PV9ky"};